import { useState, useEffect, useCallback } from 'react';

const heroWords = ['欲望', '渴望', '梦想', '激情', '力量'];

export default function HeroSection() {
  const [wordIndex, setWordIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const cycleWords = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      setWordIndex((prev) => (prev + 1) % heroWords.length);
      setIsVisible(true);
    }, 400);
  }, []);

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(cycleWords, 3000);
    return () => clearInterval(interval);
  }, [cycleWords]);

  return (
    <section className="relative w-full min-h-[100vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20landscape%20with%20flowing%20golden%20light%20waves%20and%20amber%20particles%2C%20deep%20shadow%20depths%2C%20contemplative%20atmosphere%2C%20artistic%20minimalist%20composition%2C%20fine%20art%20photography%20style%2C%20dramatic%20contrast%20between%20darkness%20and%20warm%20light%2C%20no%20people%2C%20abstract%20emotional%20landscape&width=1920&height=1080&seq=hero-desire-01&orientation=landscape)',
        }}
        role="img"
        aria-label="欲望之岛沉浸式体验背景"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50" />

      <div className="relative z-10 w-full container-custom flex flex-col items-center text-center py-24 md:py-32">
        <div className="animate-fade-in max-w-3xl">
          <p className="text-sm md:text-base tracking-[0.3em] text-primary-400/80 font-label mb-6">
            欲望之岛 · 沉浸式自我探索平台
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-100 leading-tight mb-6 text-balance">
            探索你内心深处的
            <br />
            <span
              className={`gradient-text transition-opacity duration-500 ${
                isVisible ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {heroWords[wordIndex]}
            </span>
            <span className="text-foreground-100">世界</span>
          </h1>

          <p className="text-sm md:text-lg text-foreground-400 max-w-xl mx-auto mb-8 leading-relaxed">
            欲望与理性的边界在这里被重新定义。踏上属于你的欲望之岛，
            发现最真实的自我，突破束缚，拥抱无限可能。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#categories"
              className="btn-primary !px-8 !py-3.5 !text-base !rounded-full"
            >
              开始探索
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#articles"
              className="btn-outline !px-8 !py-3.5 !text-base !rounded-full"
            >
              阅读文章
            </a>
          </div>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-3 gap-6 md:gap-12 w-full max-w-2xl">
          {[
            { number: '50+', label: '深度文章' },
            { number: '6', label: '探索领域' },
            { number: '10,000+', label: '探索者' },
          ].map((stat, i) => (
            <div
              key={stat.label}
              className="text-center animate-slide-up"
              style={{ animationDelay: `${0.3 + i * 0.15}s` }}
            >
              <div className="text-2xl md:text-3xl font-bold font-heading text-primary-400">
                {stat.number}
              </div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <a href="#features" aria-label="向下滚动">
            <div className="w-8 h-8 flex items-center justify-center text-foreground-500">
              <i className="ri-arrow-down-line text-lg"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}